import React, {Component} from 'react';
import {Lightbox} from "react-modal-image";

const poster_url = 'https://drive.google.com/file/d/1WIRdxJgz3mAze6bBy0jSllBlRKoRiNRe/view?usp=sharing';
const overview_url = 'https://drive.google.com/file/d/1jl2V4sEwAF-fgrsH0akms8_JY64xJCgX/view?usp=sharing';
const diagram_url = 'https://drive.google.com/file/d/1Eqk6afE8H7RcLI37hSBoTXsDKIuYCUz2/view?usp=sharing';

class Designtab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openResearchPaper: false,
            openOverview: false,
            openDiagram: false,
        }
    }

    openResearchPaper = () => {
        this.setState({
            openResearchPaper: true
        }, () => {
            document.body.style.overflow = 'hidden';
        })
    }
    closeResearchPaper = () => {
        this.setState({
            openResearchPaper: false
        }, () => {
            document.body.style.overflow = 'unset';
        })
    };

    openOverview = () => {
        this.setState({
            openOverview: true
        }, () => {
            document.body.style.overflow = 'hidden';
        })
    }
    closeOverview = () => {
        this.setState({
            openOverview: false
        }, () => {
            document.body.style.overflow = 'unset';
        })
    };

    openDiagram = () => {
        this.setState({
            openDiagram: true
        }, () => {
            document.body.style.overflow = 'hidden';
        })
    }
    closeDiagram = () => {
        this.setState({
            openDiagram: false
        }, () => {
            document.body.style.overflow = 'unset';
        })
    };

    downloadResearchPaper = () => {
        const newWindow = window.open(poster_url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    downloadOverview = () => {
        const newWindow = window.open(overview_url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    downloadDiagram = () => {
        const newWindow = window.open(diagram_url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }


    render() {
        return (
            <div className="row">
                <div className="col-lg-3 d-flex align-items-center">
                    <ul className="nav nav-tabs design_tab support_tab" role="tablist">
                        <li className="nav-item wow fadeInUp" data-wow-delay="0.4s">
                            <a className="nav-link active" id="one-tab" data-toggle="tab" href="#one" role="tab"
                               aria-controls="one" aria-selected="true">
                                <h5>Poster <p>Research summary.</p></h5>

                                <button className="btn btn-light" onClick={this.openResearchPaper}><i
                                    className="ti-eye"/></button>
                                {" "}
                                <button className="btn btn-light" onClick={this.downloadResearchPaper}><i
                                    className="ti-download"/></button>
                                {
                                    this.state.openResearchPaper && (
                                        <Lightbox
                                            medium={"https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2Fposter_greenhub_lk.png?alt=media&token=58c8d3b1-9fca-4d02-8c4f-17f216813bf9"}
                                            large={"https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2Fposter_greenhub_lk.png?alt=media&token=58c8d3b1-9fca-4d02-8c4f-17f216813bf9"}
                                            alt="GreenHubLK Research Paper"
                                            onClose={this.closeResearchPaper}
                                            hideDownload="true"
                                        />
                                    )
                                }
                            </a>
                        </li>
                        <li className="nav-item wow fadeInUp" data-wow-delay="0.6s">
                            <a className="nav-link" id="two-tab" data-toggle="tab" href="#two" role="tab"
                               aria-controls="two" aria-selected="false">
                                <h5>System Overview <p>Project illustration.</p> </h5>
                                <br/>
                                <button className="btn btn-light" onClick={this.openOverview}><i
                                    className="ti-eye"/></button>
                                {" "}
                                <button className="btn btn-light" onClick={this.downloadOverview}><i
                                    className="ti-download"/></button>
                                {
                                    this.state.openOverview && (
                                        <Lightbox
                                            medium={"https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2Fsystemoverview%20Final.png?alt=media&token=e9ad2fde-b038-4086-8138-048500f11104"}
                                            large={"https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2Fsystemoverview%20Final.png?alt=media&token=e9ad2fde-b038-4086-8138-048500f11104"}
                                            alt="GreenHubLK System Overview"
                                            onClose={this.closeOverview}
                                            hideDownload="true"
                                        />
                                    )
                                }
                            </a>
                        </li>
                        <li className="nav-item wow fadeInUp" data-wow-delay="0.8s">
                            <a className="nav-link" id="three-tab" data-toggle="tab" href="#three" role="tab"
                               aria-controls="three" aria-selected="false">
                                <h5>System Diagram <p>Project architecture.</p> </h5>
                                <br/>
                                <button className="btn btn-light" onClick={this.openDiagram}><i
                                    className="ti-eye"/></button>
                                {" "}
                                <button className="btn btn-light" onClick={this.downloadDiagram}><i
                                    className="ti-download"/></button>
                                {
                                    this.state.openDiagram && (
                                        <Lightbox
                                            medium={"https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2Fsystemfinal%202.png?alt=media&token=75cb7a7b-6e61-43f8-be9d-b2be77a3840d"}
                                            large={"https://firebasestorage.googleapis.com/v0/b/greenhublk-aab73.appspot.com/o/web_site%2Fsystemfinal%202.png?alt=media&token=75cb7a7b-6e61-43f8-be9d-b2be77a3840d"}
                                            alt="GreenHubLK System Diagram"
                                            onClose={this.closeDiagram}
                                            hideDownload="true"
                                        />
                                    )
                                }
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="col-lg-9">
                    <div className="tab-content support_tab_content">
                        <div className="tab-pane fade show active" id="one" role="tabpanel"
                             aria-labelledby="one-tab">
                            <div className="tab_img">
                                <img src={require("../../img/new-home/tab_2.png")} alt=""/>
                            </div>
                        </div>
                        <div className="tab-pane fade" id="two" role="tabpanel" aria-labelledby="two-tab">
                            <div className="tab_img">
                                <img src={require("../../img/new-home/tab.png")} alt=""/>
                            </div>
                        </div>
                        <div className="tab-pane fade" id="three" role="tabpanel" aria-labelledby="three-tab">
                            <div className="tab_img">
                                <img src={require("../../img/new-home/tab_3.png")} alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Designtab;
